<template>
  <div class="message-input-container">
    <div class="message-input-form">
      <textarea id="message-input"
                class="message-textarea"
                :placeholder="$t('chatBot.placeholder')"
                v-model="messageToSend"
                @keypress.enter ="handleTextAreaEnter"
      />
    </div>
    <div class="message-send">
      <button class="message-send-btn rounded-full"
              :disabled="isSendBtnDisabled"
              @click="handleSendBtnClick"
      />
    </div>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import DateFormatter from "@/utils/DateFormatter";

export default {
  name: 'BotChatForm',
  data() {
    return {
      messageToSend: '',
    }
  },
  computed: {
    ...mapGetters('user', [
        'me',
    ]),
    ...mapGetters('chatBot', [
        'isChatSent',
    ]),
    isSendBtnDisabled() {
      return this.messageToSend.trim() === '' || this.isChatSent;
    }
  },
  methods: {
    ...mapActions('chatBot', [
        'sendChatMessage',
        'updateSendChatStatus',
    ]),
    handleTextAreaEnter(e) {
      if(e.shiftKey || this.isChatSent) {
        return
      }
      this.sendMessage()
    },
    handleSendBtnClick(e) {
      if(this.isChatSent) {
        return;
      }
      this.sendMessage()
    },
    async sendMessage() {
      let text = this.messageToSend.trim();
      if(!text.length) {
        return
      }

      let data = {
        type: 'user',
        text,
        stream: false,
        userId: this.me.userId,
        // toUserId: this.me.userId,
        time: DateFormatter.getFormattedDate(Date.now(), 'HH:mm'),
      }
      await this.sendChatMessage(data);

      this.messageToSend = '';
      this.updateSendChatStatus(true);
    },
  },
}

</script>

<style lang="scss" scoped>
.message-input-container {
  background-color: #EDF4FF;
  padding: 10px;
  display: flex;
  align-items: center;
  height: 10%;
}

.message-input-form {
  background-color: #FFFFFF;
  border: none;
  border-radius: 12px;
  padding: 10px;
  width: 93%;
  height: 100%;
}

.message-textarea {
  font-size: 16px;
  color: #333;
  resize: none;
  outline: none;
  width: 100%;
  //overflow-y: hidden;
}

.message-send {
}

.message-send-btn {
  width: 30px;
  height: 30px;
  margin-left: 10px;
  cursor: pointer;
  background: $mainColor url('~@/assets/images/arrowUp_white.svg') no-repeat center / 14px auto;

  &:disabled {
    pointer-events: none;
    background: #BDD7FF url('~@/assets/images/arrowUp_white.svg') no-repeat center / 14px auto;
  }
}
</style>